import { Component, OnInit, input } from '@angular/core';
import { TenantRepository } from '@repository/tenant/tenant.repository';
import { Constants } from '@utils/Constants';
import { SkeletonComponent } from '@ui/skeleton/skeleton.component';

@Component({
  selector: 'app-tenant-logo',
  templateUrl: './tenant-logo.component.html',
  styleUrl: './tenant-logo.component.scss',
  imports: [SkeletonComponent],
})
export class TenantLogoComponent implements OnInit {
  public readonly useMasterLogo = input<boolean>(false);
  public tenantLogoSrc: string;

  public constructor(public readonly tenantRepository: TenantRepository) {}

  public ngOnInit(): void {
    if (this.useMasterLogo()) {
      this.tenantLogoSrc = Constants.MASTER_TENANT_LOGO;
      return;
    }

    this.tenantRepository.getTenantLogo().subscribe((tenantLogo) => {
      if (tenantLogo === Constants.NO_IMAGE) {
        this.tenantLogoSrc = Constants.MASTER_TENANT_LOGO;
      } else {
        this.tenantLogoSrc = tenantLogo;
      }
    });
  }
}
